import styles from './SalesTypeGratuity.css'

class SalesTypeGratuity extends React.Component {
  render () {
    const {gratuity} = this.props
    return (<div className={`${styles['marginBotGratuiti']} checkbox checkbox-primary checkbox-item checkbox-circle ng-scope checkbox-circle no-padding`}>
      {gratuity.results.map((grat, index) =>
        <div className={`${styles['borderGratuiti']} top-8 checkbox-input`}>
          <input
            type='checkbox'
            checked={this._checked(grat.id)}
            onChange={(e) => this._onChangeCheckbox(e, grat.id)}
            id={`gratuity-${grat.id}`}
            className='item-form-checkbox'
          />
          <label for={`gratuity-${grat.id}`}>{grat.name}</label>
          <div className={styles.percentageGratuiti}>{grat.amount}%</div>
        </div>
      )}
    </div>)
  }

  _onChangeCheckbox = (e, id) => {
    const {fields} = this.props
    const values = fields.getAll()
    let indexPosition = -1

    values.forEach((value, index) => {
      if (value === id) {
        indexPosition = index
      }
    })
    if (indexPosition === -1) {
      // the value doesn't exist, insert data
      fields.push(id)
    } else {
      // remove the value
      fields.remove(indexPosition)
    }
  }

  _checked = (id) => {
    const {fields} = this.props

    const values = fields.getAll()
    let checked = false
    if (values) {
      values.forEach((val) => {
        checked = checked || (val === id)
      })
    }
    return checked
  }
}

export default SalesTypeGratuity



// WEBPACK FOOTER //
// ./app/pages/Library/SalesType/SalesTypeDetail/SalesTypeGratuity/SalesTypeGratuity.js